import React, { FC, memo, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { Button } from 'shared/ui/Button';
import { useAppDispatch } from 'app/config/storeConfig/hooks';
import { logInModalActions } from 'widgets/LogInModal';
import { useScreenBreakpoints } from 'shared/utils/hooks/useScreenBreakpoints';
import { ReactComponent as AccountIcon } from 'shared/assets/icons/newIcons/AccountIcon.svg';

interface LogInButtonProps {
  className?: string;
}

export const LogInButton: FC<LogInButtonProps> = memo((props) => {
  const { className } = props;

  const { t } = useAppTranslation('header');
  const dispatch = useAppDispatch();
  const { isDesktop } = useScreenBreakpoints();

  const openLogInModal = useCallback((): void => {
    dispatch(logInModalActions.setOpened(true));
  }, [dispatch]);

  return (
    <Button
      theme="dark"
      className={!isDesktop ? 'w-[40px] h-[40px] p-0 rounded-lg' : undefined}
      containerClassName={className}
      size="small"
      onClick={openLogInModal}
      icon={!isDesktop ? <AccountIcon className="w-[25px] h-[25px] mx-[1px]" /> : undefined}
      iconPosition="prev"
    >
      {isDesktop ? t('Log in') : null}
    </Button>
  );
});
